import { UploadQualityMetricRecordsProvider } from './provider';
import { UploadComponent } from '../../csv-importer/csv-upload-wizard';
import { CONTEXT_TYPE } from '../use-upload-context-factory';

export function MetricRecordsUploadWizard() {
  return (
    <UploadQualityMetricRecordsProvider>
      <UploadComponent contextType={CONTEXT_TYPE.METRICS} />
    </UploadQualityMetricRecordsProvider>
  );
}
